import $ from 'jquery';
import selectize from 'selectize';

function HCPSearch($el,secure){
	this.$el = $el;
	this.redirectURL = this.$el.data('url') || false;
	this.init();
}

HCPSearch.prototype = {

	init: function(){


		var options = {
			valueField: 'uid',
			labelField: 'name',
			searchField: ['name','value','institution'],
			load: $.proxy(this.load,this),
			hideSelected: true,
			render:{
				option: function(item,escape){
					return '<div class="suggestion">' +
					'<div class="suggestion__title">' + escape(item.name) + '</div>' +
					'<div class="suggestion__address">' + escape(item.institution) + ', ID:' + escape(item.uid) + '</div>' +
				'</div>';
				}
			}
		}
		this.selectize = this.$el.selectize(options)[0].selectize;
		this.selectize.on('item_add', $.proxy(this.onSelected,this));
	},

	onSelected: function(value){
		var data = this.selectize.options[value];
		this.redirect(data);
	},

	redirect: function(data){
		window.location = this.redirectURL.replace("{uid}",data.uid);
	},

	load: function(query,callback){

        if (query.length < 1) return callback();

		var url = '/admin/hcps/search/';

		$.get(url + query).done(function(resp){
			callback(resp.data);
		});
	},

}

function init(){
	new HCPSearch($(this));
}

$(document).ready(()=>{
	const $hcp = $('[data-js="hcpsearch"]');
	if($hcp.length){
		$hcp.each(init);
	}
})
